var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.job.lob !== "RE" && _vm.job.lob !== "RI"
        ? _c("tab-warehouse", {
            ref: "tabWarehouse",
            attrs: {
              context: _vm.context,
              action: _vm.action,
              "cooperate-edit": _vm.cooperateEditWarehouse
            }
          })
        : _vm._e(),
      _vm.job.lob === "RE" || _vm.job.lob === "RI"
        ? _c("tab-warehouse-se", {
            ref: "tabWarehouseSe",
            attrs: {
              context: _vm.context,
              action: _vm.action,
              from: _vm.from,
              "cooperate-edit": _vm.cooperateEditWarehouse
            }
          })
        : _vm._e(),
      _vm.showTrucking
        ? _c("tab-trucking", {
            ref: "tabTrucking",
            attrs: {
              context: _vm.context,
              action: _vm.action,
              "cooperate-edit": _vm.cooperateEditTrucking
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }